import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';

import { catchError, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { ApiService } from '../services/api.service';


@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor(private router: Router, private auth: AuthService, private api: ApiService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Skip the interceptor if it has Ignore-Interceptor as X-Meta-Data.
        // Also stripe it as it is not usefull for the request
        // Note: This is needed for logging in, since when a 401 error occurs, it should not redirect.
        const params = request.params;
        const XMetaData = params.get('X-Meta-Data');
        if (XMetaData === 'Ignore-Interceptor') {
            // console.log('ignore interceptor');
            return next.handle(request.clone({ headers: request.headers.delete('X-Meta-Data', 'Ignore-Interceptor')}));
        }

        // Get the X-Api-Device val
        const apiDevice = this.api.getApiDevice();
        const apiKey = this.auth.getApiKey();
        let response;
        if(apiDevice && apiKey) {
            response = request.clone({ headers: request.headers.set('X-Api-Device', `${apiDevice}`).set('X-Api-Key', `${apiKey}`)});
        } else if (apiDevice) {
            response = request.clone({ headers: request.headers.set('X-Api-Device', `${apiDevice}`)});
        } else {
            response = request;
        }
        return next.handle(response).pipe(catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
             if (apiKey) {
                this.auth.logout();
                this.router.navigate(['/login']);
                return throwError(error);
             }
          }
          else if (error.status === 403) {
              // TODO: doesn't work since the guard handles the routing.
              // TODO: seems to be a bug in Angular
              // Redirect to login page.
              // this.router.navigate(['/login']);

              // TODO: temp solution, only works at second routing, better than nothing though.
              this.auth.logout();

              // And just to be sure return an empty 200 response so code won't break.
              return of(new HttpResponse({body: null, status: 200}));
          }
          // During other errors, just pass the error along and handle it at the caller.
          console.log('an error has occured', error);
          return throwError(error);
      }));
    }
}
